/* Bonst buy box – live pricing for subscription / one-time + quantity tiers.
   The form itself is Dawn's <product-form>; this only keeps selling_plan, quantity and prices in sync. */
(function () {
  if (customElements.get('bonst-buy-box')) return;

  function formatMoney(cents, format) {
    cents = Math.round(cents);
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}} kr';
    function num(n, prec, th, dec) {
      th = th === undefined ? ',' : th;
      dec = dec === undefined ? '.' : dec;
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      if (parts[1] && /^0+$/.test(parts[1])) return parts[0];
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    var m = fmt.match(re);
    if (!m) return num(cents, 2);
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = num(cents, 0); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      default: v = num(cents, 2);
    }
    return fmt.replace(re, v);
  }

  class BonstBuyBox extends HTMLElement {
    connectedCallback() {
      try {
        this.data = JSON.parse(this.querySelector('[data-bb-json]').textContent);
      } catch (e) {
        console.error('bonst-buy-box: bad JSON', e);
        return;
      }
      this.form = document.getElementById(this.dataset.formId);
      this.planInput = this.querySelector('[data-bb-plan-input]');
      this.qtyInput = this.querySelector('[data-bb-qty]');
      this.planId = this.data.planId ? String(this.data.planId) : null;
      var idInput = this.form && this.form.querySelector('input[name="id"]');
      this.variant = this.findVariant(idInput && idInput.value) || this.data.variants[0];

      // "30 stk. enkeltporsjoner hver måned" → number follows the chosen pack count
      this.querySelectorAll('.bonst-bb__perks li > span').forEach((sp) => {
        var t = sp.textContent;
        var m = t.match(/(\d+)(\s*stk)/i);
        if (!m) return;
        var esc = (x) => x.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        sp.innerHTML = esc(t.slice(0, m.index)) + '<b data-bb-units="' + m[1] + '">' + m[1] + '</b>' + esc(t.slice(m.index + m[1].length));
      });

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', (e) => {
        if (!this.hasChoice() && e.target.closest('.bonst-bb__packs, .bonst-bb__qty, .bonst-bb__actions')) {
          this.nudge();
          return;
        }
        var step = e.target.closest('[data-bb-step]');
        if (!step) return;
        var q = Math.max(1, Math.min(20, (parseInt(this.qtyInput.value, 10) || 1) + parseInt(step.dataset.bbStep, 10)));
        this.qtyInput.value = q;
        this.update();
      });
      if (this.qtyInput && this.qtyInput.type === 'number') {
        this.qtyInput.addEventListener('input', () => this.update());
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || event.data.sectionId !== this.dataset.sectionId) return;
          var v = event.data.variant;
          if (!v) return;
          this.variant = this.findVariant(v.id) || this.variant;
          // Dawn resets the button label on variant change – re-apply our price afterwards
          setTimeout(() => this.update(), 0);
        });
      }
      if (this.data.gift && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (!evt || evt.source !== 'product-form' || !this.findVariant(evt.productVariantId)) return;
          this.addGift();
        });
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.unsub) this.unsub();
      if (this.unsubCart) this.unsubCart();
    }

    // Appstle "FREE Gift" (e.g. vannflaske at 3+ pakker) – same line properties Appstle's own widget uses
    addGift() {
      var g = this.data.gift;
      var root = (window.routes && window.routes.cart_url) || '/cart';
      fetch(root + '.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => {
          var mine = cart.items.filter((i) => this.findVariant(i.variant_id)).reduce((n, i) => n + i.quantity, 0);
          var has = cart.items.some((i) => i.variant_id === g.variant && i.properties && i.properties._appstle_bundle_combo_id === 'free_gift');
          if (mine < g.min || has) return null;
          return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: g.variant, quantity: 1, properties: {
              '_appstle-bb-id': g.id, '__appstle-bb-name': g.name, '_appstle_bundles_type': 'VOLUME_DISCOUNT', '_appstle_bundle_combo_id': 'free_gift'
            } }] })
          }).then(() => fetch(window.location.pathname + '?sections=cart-icon-bubble'))
            .then((r) => r.json())
            .then((s) => {
              var t = document.getElementById('cart-icon-bubble');
              var html = s && s['cart-icon-bubble'];
              if (!t || !html) return;
              var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (src) t.innerHTML = src.innerHTML;
            });
        })
        .catch(() => {});
    }

    findVariant(id) {
      if (!id) return null;
      return this.data.variants.find((v) => String(v.id) === String(id)) || null;
    }

    onChange(e) {
      if (e.target.matches('[data-bb-plan-select]')) this.planId = e.target.value;
      if (e.target.name && e.target.name.indexOf('bonst-pack-') === 0) this.qtyInput.value = e.target.value;
      this.update();
    }

    hasChoice() {
      if (!this.querySelector('.bonst-bb__opt-input')) return true; // no subscription on this product
      return !!this.querySelector('.bonst-bb__opt-input:checked');
    }

    nudge() {
      var opts = this.querySelector('.bonst-bb__opts');
      if (!opts) return;
      opts.classList.remove('is-nudge');
      void opts.offsetWidth;
      opts.classList.add('is-nudge');
      var r = opts.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) opts.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => opts.classList.remove('is-nudge'), 900);
    }

    isSub() {
      var r = this.querySelector('.bonst-bb__opt-input:checked');
      return !!(r && r.value === 'sub');
    }

    tierPct(qty, sub) {
      // the highest tier reached wins (Gummies: 3 = 3-for-2, 5 = 20 %)
      var best = null;
      (this.data.tiers || []).forEach((t) => {
        if (qty >= t.qty && (!best || t.qty > best.qty)) best = t;
      });
      if (!best) return 0;
      return !sub && best.once !== null && best.once !== undefined ? best.once : best.pct;
    }

    unitPrice(sub) {
      var v = this.variant;
      if (sub && this.planId && v.plans && v.plans[this.planId] !== undefined) return v.plans[this.planId];
      return v.price;
    }

    total(qty, sub) {
      return Math.round(this.unitPrice(sub) * qty * (1 - this.tierPct(qty, sub) / 100));
    }

    update() {
      var fmt = this.data.moneyFormat;
      var chosen = this.hasChoice();
      var sub = chosen ? this.isSub() : true;
      var qty = parseInt(this.qtyInput && this.qtyInput.value, 10) || 1;
      var full = this.variant.price * qty;
      var total = this.total(qty, sub);

      var packs = this.querySelector('.bonst-bb__packs');
      if (packs) {
        packs.disabled = !chosen;
        packs.classList.toggle('is-locked', !chosen);
      }
      this.querySelectorAll('[data-bb-step]').forEach((b) => { b.disabled = !chosen; });
      var submit = this.querySelector('.bonst-bb__submit');
      var label = submit && submit.querySelector('span');
      if (submit && this.variant.available) {
        submit.disabled = !chosen;
        if (label) label.textContent = chosen ? (this.dataset.addLabel || label.textContent) : (this.dataset.lockLabel || label.textContent);
      }

      if (this.planInput) {
        this.planInput.disabled = !(chosen && sub);
        if (this.planId) this.planInput.value = this.planId;
      }

      this.querySelectorAll('.bonst-bb__opt').forEach((o) => {
        o.classList.toggle('is-selected', !!o.querySelector('.bonst-bb__opt-input:checked'));
      });

      // option cards show the per-pack price
      var subUnit = this.querySelector('[data-bb-sub-unit]');
      if (subUnit) subUnit.textContent = formatMoney(this.unitPrice(true), fmt);
      var subWas = this.querySelector('[data-bb-sub-was]');
      if (subWas) subWas.textContent = formatMoney(this.variant.price, fmt);
      var onceUnit = this.querySelector('[data-bb-once-unit]');
      if (onceUnit) onceUnit.textContent = formatMoney(this.variant.price, fmt);

      // headline price = what goes in the cart now
      this.querySelector('[data-bb-price]').textContent = (chosen ? '' : 'Fra ') + formatMoney(total, fmt);
      var cmp = this.querySelector('[data-bb-compare]');
      var save = this.querySelector('[data-bb-save]');
      var saved = full - total;
      cmp.hidden = !chosen || saved <= 0;
      save.hidden = !chosen || saved <= 0;
      cmp.textContent = formatMoney(full, fmt);
      save.textContent = 'Du sparer ' + formatMoney(saved, fmt);

      this.querySelectorAll('[data-bb-units]').forEach((b) => {
        b.textContent = parseInt(b.dataset.bbUnits, 10) * (chosen ? qty : 1);
      });

      var btnPrice = this.querySelector('[data-bb-btn-price]');
      if (btnPrice) btnPrice.textContent = chosen ? formatMoney(total, fmt) : '';

      // pack chips ("/ pakke" or "/ pose" – taken from the first chip's label, e.g. "1 pose")
      var firstLabel = this.querySelector('.bonst-bb__pack-label');
      var unit = firstLabel ? firstLabel.textContent.trim().replace(/^\d+\s*/, '') || 'pakke' : 'pakke';
      this.querySelectorAll('[data-bb-pack-each]').forEach((el) => {
        var q = parseInt(el.dataset.bbPackEach, 10);
        el.textContent = formatMoney(Math.round(this.total(q, sub) / q / 100) * 100, fmt) + (q > 1 ? ' / ' + unit : '');
      });
      this.querySelectorAll('[data-bb-pack-save]').forEach((el) => {
        var q = parseInt(el.dataset.bbPackSave, 10);
        var s = this.variant.price * q - this.total(q, sub);
        el.textContent = s > 0 ? 'Spar ' + formatMoney(Math.round(s / 100) * 100, fmt) : '';
      });
      this.querySelectorAll('.bonst-bb__pack').forEach((p) => {
        p.classList.toggle('is-selected', !!p.querySelector('input:checked'));
      });

      // simple mode: nudge toward next tier
      var hint = this.querySelector('[data-bb-hint]');
      if (hint) {
        var tp = (t) => (!sub && t.once !== null && t.once !== undefined ? t.once : t.pct);
        var next = (this.data.tiers || []).filter((t) => tp(t) > 0 && t.qty > qty).sort((a, b) => a.qty - b.qty)[0];
        if (next) next = { qty: next.qty, pct: Math.round(tp(next) * 10) / 10 };
        var cur = Math.round(this.tierPct(qty, sub) * 10) / 10;
        var pc = function (n) { return String(n).replace('.', ','); };
        if (next) {
          hint.textContent = (cur > 0 ? 'Du får ' + pc(cur) + ' % mengderabatt. ' : '') +
            'Kjøp ' + next.qty + ' pakker og få ' + pc(next.pct) + ' % mengderabatt' + (sub ? ' i tillegg til abonnementsrabatten.' : '.');
        } else if (cur > 0) {
          hint.textContent = 'Du får ' + pc(cur) + ' % mengderabatt – trekkes automatisk i handlekurven.';
        } else {
          hint.textContent = '';
        }
      }

      if (!this.variant.available) {
        if (btnPrice) btnPrice.textContent = '';
      }
    }
  }

  customElements.define('bonst-buy-box', BonstBuyBox);
})();